export async function fetchSignedUrl(
  storagePath: string,
  bucket?: string,
  expires?: number,
) {
  try {
    const res = await fetch('/api/admin/get-signed-url', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ storage_path: storagePath, bucket, expires }),
    });
    if (!res.ok) {
      const err = await res.text();
      throw new Error(err || 'Failed to fetch signed url');
    }
    const json = await res.json();
    return json.signedUrl ?? null;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('fetchSignedUrl error', e);
    return null;
  }
}
